import Button from '@material-ui/core/Button';
import CircularProgress from '@material-ui/core/CircularProgress';
import InputAdornment from '@material-ui/core/InputAdornment';
import TextField from '@material-ui/core/TextField';
import Tooltip from '@material-ui/core/Tooltip';
import PermissionHide from 'components/PermissionHide';
import React from 'react';
import { FormattedNumber } from 'react-intl';
import { connect } from 'react-redux';
import { toast } from 'react-toastify';
import { addAffiliateInvoice } from 'store/Orbita/Invoice/actions';
import { run, ruleRunner } from 'validations/ruleRunner';
import { required, isEmail } from 'validations/rules';

import type { DispatchProp } from 'react-redux';

const fieldValidations = {
  email: ruleRunner('email', 'e-mail', required, isEmail),
};

type AddAffiliate = {
  affiliate_id: number;
  affiliate_email: string;
  affiliate_name: string;
  message: string;
  isFetching?: boolean;
};

interface IProps extends DispatchProp<any> {
  classes: any;
  invoice: any;
  addAffiliate: AddAffiliate;
  updateInvoice: any;
}

type InvoiceAffiliate = {
  id: number;
  name: string | null;
  email: string | null;
  differentiated_comission: number | null;
};

type InvoiceGain = {
  id: number;
  name: string;
  email: string;
  type: string;
  amount?: number;
  gross_gain?: number;
  net_income?: number;
  refunded_amount?: number;
  sale_value?: number;
};

interface IStates {
  email: string;
  validationErrors: any;
  affiliatesGains: InvoiceGain[];
  invoiceAffiliate: InvoiceAffiliate;
}

class Affiliates extends React.Component<IProps, IStates> {
  constructor(props: IProps) {
    super(props);

    this.state = {
      email: '',
      affiliatesGains: [],
      validationErrors: {},
      invoiceAffiliate: {
        id: 0,
        name: null,
        email: null,
        differentiated_comission: null,
      },
    };
  }

  errorFor = (field: any) => {
    return this.state.validationErrors[field] || '';
  };

  isValid = (field: any) => {
    return this.state.validationErrors[field] ? true : false;
  };

  onValidation = (field: string) => {
    let validationErrors = this.state.validationErrors;
    let obj = run(this.state, [fieldValidations[field]]);

    validationErrors[field] = obj[field];

    for (let prop in validationErrors) {
      if (!validationErrors[prop]) {
        delete validationErrors[prop];
      }
    }

    this.setState({
      validationErrors,
    });
  };

  handleChangeInput = (name: string) => (event: any) => {
    let newState = this.state;
    newState[name] = event.target.value;

    this.setState(newState, () => this.onValidation(name));
  };

  handleClickAdcAffiliate = async () => {
    let newState = this.state;
    let validationErrors = {};
    let array = [];

    for (let prop in fieldValidations) {
      array.push(fieldValidations[prop]);
    }

    validationErrors = run(newState, array);

    this.setState({
      validationErrors,
    });

    if (Object.keys(validationErrors).length === 0) {
      try {
        await this.props.dispatch(addAffiliateInvoice(this.props.invoice.id, this.state.email));
        const { affiliate_id, affiliate_email, affiliate_name } = this.props.addAffiliate;
        const invoiceAffiliate: InvoiceAffiliate = {
          id: affiliate_id,
          name: affiliate_name,
          email: affiliate_email,
          differentiated_comission: null,
        };
        this.setState({
          invoiceAffiliate,
          affiliatesGains: [
            {
              ...invoiceAffiliate,
              type: 'Affiliate',
            },
          ],
        });
        toast.success('Afiliado adicionado com sucesso!');
      } catch (error) {
        toast.error(error);
      }
      return;
    }

    toast.error('O campo e-mail está inválido');
  };

  componentDidMount() {
    const { invoice } = this.props;
    const invoiceGains: InvoiceGain[] = invoice.gains || [];
    const invoiceAffiliate: InvoiceAffiliate = invoice.affiliate;
    const affiliatesGains = invoiceGains.filter((gain) => gain.type === 'Affiliate');
    this.setState({ affiliatesGains, invoiceAffiliate });
  }

  renderAdornment = (addAffiliate: any, isFetching: boolean, isBump: boolean) => {
    if (isBump) {
      return (
        <Tooltip title='Não é possível adicionar afiliados em faturas de Order Bump' placement='top'>
          <InputAdornment position='end' style={{ border: 0 }}>
            <Button size='small' variant='outlined' disabled>
              Adicionar
            </Button>
          </InputAdornment>
        </Tooltip>
      );
    }

    return (
      <InputAdornment position='end' style={{ border: 0 }}>
        <Button size='small' variant='outlined' onClick={this.handleClickAdcAffiliate} disabled={addAffiliate && isFetching}>
          Adicionar
          {addAffiliate && isFetching && <CircularProgress size={19} style={{ marginLeft: 10, color: '#fff' }} />}
        </Button>
      </InputAdornment>
    );
  };

  render() {
    const { addAffiliate, classes, invoice } = this.props;
    const { affiliatesGains, invoiceAffiliate } = this.state;
    const hasInvoiceAffiliate = invoiceAffiliate.id !== 0;
    const isProducer = invoice.product.producer_id === Number(localStorage.getItem('id'));
    const shouldShowAddAffiliateButton = !hasInvoiceAffiliate && isProducer;

    return (
      <React.Fragment>
        <div className={classes.affiliates}>
          <div className='affiliates__title'>
            <div>Afiliados</div>
            <div>Comissão</div>
          </div>

          <div className='affiliates__content'>
            {affiliatesGains.length > 0 ? (
              <>
                {affiliatesGains.map((gain) => (
                  <div key={gain.id} className='affiliates__row'>
                    <div>
                      {gain.name} ({gain.email})
                      {gain.id === invoiceAffiliate.id && invoiceAffiliate.differentiated_comission && (
                        <span className='--commission'> - Comissão diferenciada</span>
                      )}
                    </div>
                    <div>
                      <PermissionHide inverse={1} action='myeduzz:minhas-vendas:ocultar-valores'>
                        {'amount' in gain ? <FormattedNumber value={gain.amount || 0} format='BRL' /> : <em>Calculando...</em>}
                      </PermissionHide>
                      <PermissionHide inverse={false} action='myeduzz:minhas-vendas:ocultar-valores'>
                        <em>oculto</em>
                      </PermissionHide>
                    </div>
                  </div>
                ))}
              </>
            ) : (
              <div>Não há afiliados vinculado a fatura.</div>
            )}
          </div>

          {shouldShowAddAffiliateButton && (
            <div className={classes.affiliates}>
              <div className='m16'></div>

              <div className='affiliates__title'>
                <div>Adicionar afiliado</div>
              </div>

              <div className='affiliates__input'>
                <TextField
                  id='email'
                  placeholder='Digite o e-mail do afiliado'
                  fullWidth
                  required
                  onChange={this.handleChangeInput('email')}
                  error={this.isValid('email')}
                  helperText={this.isValid('email') && this.errorFor('email')}
                  value={this.state.email}
                  autoComplete='off'
                  InputProps={{
                    disableUnderline: true,
                    endAdornment: this.renderAdornment(addAffiliate, addAffiliate.isFetching, invoice.order_bump),
                  }}
                  InputLabelProps={{
                    shrink: true,
                  }}
                />
              </div>
            </div>
          )}
        </div>
      </React.Fragment>
    );
  }
}

function mapStateToProps(state: any) {
  return {
    addAffiliate: state.orbita.Invoice.addAffiliate,
  };
}

export default connect(mapStateToProps)(Affiliates);
